function tooltip(_val) {
  if (!arguments.length) return this.__attrs__.tooltip;
  if (typeof _val === 'boolean') {
    if (_val) {
      _val = {sortByValue: 'natural'};
    } 
  } 
  if (typeof _val === 'object') {
    if (!_val.sortByValue) _val.sortByValue = 'natural';
  }
  this.__attrs__.tooltip = _val;
  return this;
}

export default tooltip;


// WEBPACK FOOTER //
// ../node_modules/daisy-chart/src/layouts/default/tooltip.js